<div *ngIf="exibirLoader">
  <app-loader></app-loader>
</div>

<footer
  class="footer"
  [ngClass]="{
    'footer-without-bg': paginaAtual!.link! === '/',
    'footer-palito': coresPalitoPremiado
  }"
  id="footercontent"
  *ngIf="exibir && !appOnly"
>
  <div class="footer__container">
    <div class="footer__header">
      <div class="footer__logo__cs">
        <img
          src="assets/images/logos/cacaulovers.png"
          (click)="irParaHome()"
          class="cs_logo_escrito"
          alt="Cacau Show"
          style="filter: brightness(0) invert(1)"
        />
      </div>

      <div class="footer__policyLinks">
        <div class="policyLinks">
          <div class="footer__policys">
            <button
              (click)="irPara('/cadastro_parceiros', false)"
              class="footer__button"
              [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
            >
              Parceria Lovers
            </button>
            <button
              (click)="this.mostrarPopupTermos()"
              class="footer__button"
              [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
            >
              Termos de Uso
            </button>
            <button
              (click)="this.mostrarPopupRegulamento('regulamento')"
              class="footer__button"
              [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
            >
              Regulamentos
            </button>
            <button
              (click)="
                this.mostrarPopupRegulamento('regulamentoPalitoPremiado25')
              "
              class="footer__button"
              [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
            >
              Regulamento Palito Premiado 2025
            </button>
            <a
              (click)="handleGoToSacCacaulovers()"
              class="footer__button"
              [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
            >
              FAQ
            </a>
            <button
              (click)="handleGoToSac()"
              class="footer__button"
              [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
            >
              SAC
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="footer__footer">
      <div class="footer__informativo">
        <div class="footer__logo">
          <a (click)="irParaEcommerce()">
            <img
              src="assets/images/logos/cs_footer.png"
              class="cs_footer"
              [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
              alt="Cacau Show"
            />
          </a>
        </div>
        <div class="footer__copyrightText">
          <div
            class="copyrightText"
            [ngClass]="{ 'footer-palito': coresPalitoPremiado }"
          >
            © Copyright 2022. Todos os direitos reservados. ASHOW MARKETING DE
            SERVIÇOS LTDA CNPJ 45.837.391/0001-31.
          </div>
        </div>
      </div>

      <div class="footer__socialLinks">
        <div class="content-asset">
          <ul>
            <li [ngClass]="{ 'footer-palito': coresPalitoPremiado }">
              <a
                href="https://www.facebook.com/CacauShow"
                target="_blank"
                title="Facebook"
              >
                <span class="fa fa-facebook-f fa-2x"></span>
              </a>
            </li>
            <li [ngClass]="{ 'footer-palito': coresPalitoPremiado }">
              <a
                href="https://www.instagram.com/cacaulovers"
                target="_blank"
                title="Instagram"
              >
                <span class="fa fa-instagram fa-2x"></span>
              </a>
            </li>
            <li [ngClass]="{ 'footer-palito': coresPalitoPremiado }">
              <a
                href="https://www.youtube.com/user/CacauShowBR"
                target="_blank"
                title="Youtube"
              >
                <span class="fa fa-youtube-play fa-2x"></span>
              </a>
            </li>
            <li [ngClass]="{ 'footer-palito': coresPalitoPremiado }">
              <a
                href="https://www.tiktok.com/@cacaushow?is_from_webapp=1&sender_device=pc"
                target="_blank"
                title="TikTok"
              >
                <img
                  src="../../../../../assets/images/icons/tiktok.png"
                  alt=""
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- Modal Generico -->
<lovers-popup
  [exibir]="exibePopupGenerico"
  (onClose)="exibePopupGenerico = false"
  tamanho="grande"
>
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-popup>
